import { debateConfig } from '../../config';

// The homepage is served by `[website]/home.tsx`, so its ISR route is `/home`, not `/`.
export const ssrRevalidateHomeData = (websiteBasePath: string, publicKey: string) =>
  ssrRevalidateRouteData(websiteBasePath, '/home', publicKey);

// Purges the GraphDebate front ISR cache for one static route so a front action
// (topic deletion, article publish, logo click) refreshes the page immediately
// instead of waiting for the 600s ISR window. Mirrors the BO `refreshGDFront`
// (back-office/src/js/services/websites.js): the front handler needs BOTH the
// `path` query (to build `/fr/<tenant><path>`) and the `public-key` header (to
// resolve `<tenant>`). Without them the purge targets a key that was never cached
// and silently no-ops.
export const ssrRevalidateRouteData = async (
  websiteBasePath: string = '/',
  routePath: string,
  publicKey: string,
) => {
  // Bail out without the tenant key rather than sending `public-key: ''`, which
  // would make the endpoint fall back to its DEFAULT_KEY and purge the wrong
  // tenant. Mirrors the BO guard (`if (!website.public_key) return;`). Happens
  // while the website context is still loading (EMPTY_WEBSITE.key === '').
  if (!publicKey) return;

  const gdBasePathToHandle = websiteBasePath.slice(0, -1);
  try {
    // Verify that routePath parameter is a real path
    if (!routePath.startsWith('/')) throw new Error('Invalid route path: must start with /');
    if (routePath.includes(' ')) throw new Error('Invalid route path: must not contain any spaces');

    await fetch(`${gdBasePathToHandle}/api/revalidate?path=${routePath}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${debateConfig.ISR_REVALIDATE_TOKEN}`,
        'public-key': publicKey,
      },
    });
  } catch {
    // Best-effort: a failed purge just falls back to the normal ISR window.
  }
};
